// src/services/evaluationService.js

import api from './api';

export const autoEvaluateOrder = async (orderId, evaluationData) => {
  try {
    const response = await api.post(`/evaluation/auto/${orderId}`, evaluationData);
    console.log(`Auto-evaluated order ${orderId}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error in auto-evaluating order ${orderId}:`, error.response?.data || error.message);
    throw error;
  }
};

/// ✅ Update manual score by Order ID. This is called by MANUAL EVALUATOR mandatorily
export const updateManualScore = async (orderId, manualScore) => {
  console.log(`[ORDER SERVICE] updateManualScore(${orderId}) called - Sending manual score update...`);
  console.log(`[ORDER SERVICE] updateManualScore(${orderId}) - Score to apply:`, manualScore);

  try {
    const response = await api.put(`/evaluation/orders/${orderId}/manual-score`, {
      cwe_m_01_manual_score: manualScore
    });

    console.log(`[ORDER SERVICE] updateManualScore(${orderId}) - Response received:`, response);
    console.log(`[ORDER SERVICE] updateManualScore(${orderId}) - Updated Data:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`[ORDER SERVICE] updateManualScore(${orderId}) - Error occurred:`, error.response?.data || error.message);
    throw error;
  }
};


/// ✅ Edit Auto and Manual Scores by Order ID. This is called by APPROVER if needed

export const editAutoAndManualScores = async (orderId, editedScores) => {
  console.log(`[ORDER SERVICE] Starting editAutoAndManualScores for Order ID: ${orderId}`);
  console.debug(`[ORDER SERVICE] Edited Scores Data: ${JSON.stringify(editedScores)}`);

  try {
    // Making the PUT request
    const response = await api.put(`/evaluation/orders/${orderId}/editedScores`, editedScores);
    
    // Log the response after successful request
    console.log(`[ORDER SERVICE] Successfully updated scores for Order ID: ${orderId}`);
    console.debug(`[ORDER SERVICE] Response Data: ${JSON.stringify(response.data)}`);

    return response.data;
  } catch (error) {
    // Log any errors that occur
    console.error(`[ORDER SERVICE] editAutoAndManualScores(${orderId}) - Error occurred:`, error.response?.data || error.message);
    throw error;
  }
};






// i think this is redunadant
export const manualEvaluateOrder = async (orderId, evaluationData) => {
  try {
    const response = await api.post(`/evaluation/manual/${orderId}`, evaluationData);
    console.log(`Manually evaluated order ${orderId}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error in manual evaluation of order ${orderId}:`, error.response?.data || error.message);
    throw error;
  }
};

export const approveOrder = async (orderId, approvalData) => {
  try {
    const response = await api.post(`/evaluation/approve/${orderId}`, approvalData);
    console.log(`Approved order ${orderId}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error approving order ${orderId}:`, error.response?.data || error.message);
    throw error;
  }
};
 



/// ✅ Final Submit Order Evaluation by Order ID. This is called when APPROVER clicks "Final Submit"

export const finalizeOrderEvaluation = async (orderId) => {
  console.log(`[ORDER SERVICE] Starting finalizeOrderEvaluation for Order ID: ${orderId}`);

  try {
    // Making the PUT request to finalize the order evaluation
    const response = await api.put(`/evaluation/orders/${orderId}/finalSubmit`);
    
    // Log the response after successful request
    console.log(`[ORDER SERVICE] Successfully finalized evaluation for Order ID: ${orderId}`);
    console.debug(`[ORDER SERVICE] Response Data: ${JSON.stringify(response.data)}`);

    return response.data;
  } catch (error) {
    // Log any errors that occur
    console.error(`[ORDER SERVICE] finalizeOrderEvaluation(${orderId}) - Error occurred:`, error.response?.data || error.message);
    throw error;
  }
};
